<template>
  <div id="Stats-results-grid-view">
    <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        :context="context"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="statsList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true" 
        :pagination="false"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
    </ag-grid-vue>
  </div>
</template>
<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import LFCellActions from './LocationForecastStatsCellActions.vue'

import GradeCalculationTypeEnum  from "../../GradeCalculationTypeEnum.js";
import MeasuredElementEnum  from "../../MeasuredElementEnum.js";

export default {
  name:"LocationStatsGrid",  
  components: {
    AgGridVue
  },
  props: {
    gradeCalculationType: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      defaultColDef: {
        sortable: true,
        resizable: true        
      },
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.locationForecastId;
        }
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'locationForecastId',
          width: 175,
          editable: false,
          sortable: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: Vue.extend(LFCellActions)
        },
        {
          headerName: this.$t('GradeControl.Location.Name'),
          field: "locationCode",
          width: 165
        },
        {
          headerName: this.$systemUnits.getDensityLabel(),
          field: "forecastDensity",
          width: 110,
          valueGetter: (params) => this.$systemUnits.convertDensityRounded(params.data.forecastDensity)
        },
        {
          headerName: this.$systemUnits.getTonnageLabel(),
          children: [
            {
              headerName: this.$t('GradeControl.Forecast.Name'),
              field: "forecastTonnage",
              width: 120,
              valueGetter: (params) => this.$systemUnits.convertTonnage(params.data.forecastTonnage).toFixed(2)
            },
            {
              headerName: this.$t('GradeControl.Actual'),
              field: "actualTonnage",
              valueGetter: (params) => this.$systemUnits.convertTonnage(params.data.actualTonnage).toFixed(2),
              width: 120
            }
          ]
        },
        {
          headerName: this.$systemUnits.getGradeLabel("Grade"),
          children: [
            {
              headerName: "Average",
              field: "averageGrade",
              width: 120,
              valueFormatter: this.formatGrade,
              valueGetter: (params) => {
                const result = this.getGradeStats(params.data, this.$props.gradeCalculationType);
                if (result)
                  return this.$systemUnits.convertGradeRounded(result.averageGrade);

                return "";
              }
            },
            {
              headerName: "Median",
              field: "medianGrade",
              width: 120,
              valueFormatter: this.formatGrade,
              valueGetter: (params) => {
                const result = this.getGradeStats(params.data, this.$props.gradeCalculationType);
                if (result)
                  return this.$systemUnits.convertGradeRounded(result.medianGrade);

                return "";
              }
            },
            {
              headerName: "Min",
              field: "minGrade",
              width: 120,
              valueFormatter: this.formatGrade,
              valueGetter: (params) => {
                const result = this.getGradeStats(params.data, this.$props.gradeCalculationType);
                if (result)
                  return this.$systemUnits.convertGrade(result.minGrade);

                return "";
              }
            },
            {
              headerName: "Max",
              field: "maxGrade",
              width: 120,
              valueFormatter: this.formatGrade,
              valueGetter: (params) => {
                const result = this.getGradeStats(params.data, this.$props.gradeCalculationType);
                if (result)
                  return this.$systemUnits.convertGrade(result.maxGrade);

                return "";
              }
            }
          ]
        }
      ],
      components: {
        LFCellActions
      }
    }
  },
  computed: {
    statsList() {
      return this.$store.state.gradeControl.forecastStatsList;
    }
  },
  methods: {
    getGradeStats(stat, gradeCalculation) {
      switch (gradeCalculation) {
      case GradeCalculationTypeEnum.SampleOnly:
        return stat.elementsGradeStats[MeasuredElementEnum.Gold];
      case GradeCalculationTypeEnum.SampleOrForecast:
        return stat.elementsGradeStats[MeasuredElementEnum.Gold];
      case GradeCalculationTypeEnum.SampleOnlyCapped:
        return stat.cappedElementsGradeStats[MeasuredElementEnum.Gold];
      case GradeCalculationTypeEnum.SampleOrForecastCapped:
        return stat.cappedElementsGradeStats[MeasuredElementEnum.Gold];
      }
    },
    selectLocationForecast(data) {
      this.$emit("onSelectLocationForecast", data);
    },
    formatTonnage(params) {
      return this.$options.filters.toInteger(params.value);
    },
    formatGrade(params) {
      return this.$options.filters.toFriendlyGrade(params.value);
    },
    fetchStats(projectId, startDate, endDate) {
      return this.$store.dispatch("gradeControl/fetchPeriodForecastStats",  {
        startDate,
        endDate,
        projectId
      });
    },
    getSelectedForecasts() {
      const rows = this.gridApi.getSelectedRows();
      return rows.map(l => l.locationForecastId);
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>
<style lang="scss">
#Stats-results-grid-view {
   .ag-header-group-text {
     text-align: center;
     border: 1px;
   }
   .ag-header-group-cell-label {
     align-content: center;
   }
}
  </style>
